/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_yt_shorts_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Where do I find the Shorts link?`)
};

const es_yt_shorts_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Dónde encuentro el enlace de un Short?`)
};

const de_yt_shorts_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wo finde ich den Shorts-Link?`)
};

const nl_yt_shorts_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Waar vind ik de link van een Short?`)
};

const fr_yt_shorts_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Où trouver le lien d’un Short ?`)
};

const it_yt_shorts_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dove trovo il link di uno Short?`)
};

const pt_br2_yt_shorts_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Onde encontro o link do Shorts?`)
};

const pt_yt_shorts_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Onde encontro o link de um Short?`)
};

const ja_yt_shorts_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Shortsのリンクはどこで見つけられますか？`)
};

const zh_yt_shorts_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`在哪里可以找到 Shorts 链接？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const yt_shorts_faq2_q = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.yt_shorts_faq2_q(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("yt_shorts_faq2_q", locale)
	if (locale === "en") return en_yt_shorts_faq2_q(inputs)
	if (locale === "es") return es_yt_shorts_faq2_q(inputs)
	if (locale === "de") return de_yt_shorts_faq2_q(inputs)
	if (locale === "nl") return nl_yt_shorts_faq2_q(inputs)
	if (locale === "fr") return fr_yt_shorts_faq2_q(inputs)
	if (locale === "it") return it_yt_shorts_faq2_q(inputs)
	if (locale === "pt-BR") return pt_br2_yt_shorts_faq2_q(inputs)
	if (locale === "pt") return pt_yt_shorts_faq2_q(inputs)
	if (locale === "ja") return ja_yt_shorts_faq2_q(inputs)
	return zh_yt_shorts_faq2_q(inputs)
};